import React from "react";

const MIN = 8;

function score(pw) {
  let s = 0;
  if (pw.length >= MIN) s++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) s++;
  if (/\d/.test(pw)) s++;
  if (/[^A-Za-z0-9]/.test(pw)) s++;
  return s;
}

const LEVELS = [
  { label: "Too short", color: "bg-slate-300", text: "text-slate-400" },
  { label: "Weak", color: "bg-rose-500", text: "text-rose-600" },
  { label: "Fair", color: "bg-amber-500", text: "text-amber-600" },
  { label: "Good", color: "bg-blue-500", text: "text-blue-600" },
  { label: "Strong", color: "bg-emerald-500", text: "text-emerald-600" },
];

export function PasswordStrength({ value = "", testId = "password-strength" }) {
  const pw = value || "";
  const tooShort = pw.length > 0 && pw.length < MIN;
  const s = pw.length === 0 ? 0 : score(pw);
  const lvl = LEVELS[s];
  return (
    <div className="mt-1.5" data-testid={testId}>
      <div className="flex gap-1">
        {[0, 1, 2, 3].map((i) => (
          <span key={i} className={`h-1 flex-1 rounded-full transition-colors ${pw.length > 0 && i < s ? lvl.color : "bg-slate-200"}`} />
        ))}
      </div>
      <p className={`text-xs mt-1 ${tooShort ? "text-rose-600" : pw.length ? lvl.text : "text-slate-400"}`} data-testid={`${testId}-label`}>
        {pw.length === 0
          ? `Use at least ${MIN} characters, with a mix of upper & lower case, a number and a symbol.`
          : tooShort
            ? `At least ${MIN} characters required (${pw.length}/${MIN}).`
            : `Password strength: ${lvl.label}`}
      </p>
    </div>
  );
}
